import React, { useState, useEffect } from 'react';
import { 
  Stack, 
  Text, 
  Paper,
  Rating
} from '@mantine/core';
import { ImageDetails } from '../../../../../types/Image';

interface RatingSectionProps {
  rating: number;
  onSave: (rating: number) => void;
}

export const RatingSection: React.FC<RatingSectionProps> = ({ rating: initialRating, onSave }) => {
  const [rating, setRating] = useState(initialRating || 0);
  
  // Update rating when prop changes
  useEffect(() => {
    setRating(initialRating || 0);
  }, [initialRating]);

  return (
    <Stack gap={0} style={{flex: 1}}>
      <Text fw={500} size={'sm'}>Rating</Text>
      <Paper mt={5} withBorder radius="sm" style={{overflow: 'hidden'}}>
        <Rating 
          p={10} 
          value={rating} 
          onChange={(newRating) => {
            setRating(newRating);
            onSave(newRating);
          }} 
          color="gray"
        />
      </Paper>
    </Stack>
  );
};
